<section>
  <app-datatable
    data-automation-id="draft-eforms-queue_202128102229"
    [columns]="columns"
    [dataUrl]="dataUrl"
    [defaultSort]="defaultSort"
    [scrollV]="false"
    [scrollH]="true"
    [actionTmpl]="actions"
    [warningMessage]="dtWarningMessage"
    [preventInitialLoad]="true"
  ></app-datatable>
</section>

<ng-template #idTemplate let-row="row" let-value="value">
  <a
    *ngIf="row.filingSubmissionStatusId !== FilingSubmissionStatus.eFormSubmissionError"
    [routerLink]="getDraftEformLink(row)"
    [queryParams]="
      row.filingSubmissionStatusId === FilingSubmissionStatus.ReadyToSubmit
        ? { skipToReview: true }
        : null
    "
    data-automation-id="draft-eforms-queue_202127111154"
  >
    <span class="visually-hidden">Navigate to eForm</span>
    {{ value }}
  </a>
  <strong
    *ngIf="row.filingSubmissionStatusId === FilingSubmissionStatus.eFormSubmissionError"
    data-automation-id="draft-eforms-queue_202127111159"
  >
    {{ value }}
  </strong>
</ng-template>

<ng-template #associatedWithTemplate let-row="row" let-value="value">
  <ng-container *ngIf="row.relatedObjectId">
    <a
      class="mat-button-link"
      tabindex="0"
      [routerLink]="
        row?.relatedObjectId !== null && row.relatedObjectTypeCode !== null
          ? [AppUrls.detailsForSystemType(row.relatedObjectId, row.relatedObjectTypeCode)]
          : null
      "
      target="_blank"
      data-automation-id="draft-eforms-queue_202127111204"
    >
      {{ value }}
    </a>
  </ng-container>
</ng-template>

<ng-template #actions let-row="row">
  <mat-menu class="mat-simple-menu" #appMenu="matMenu">
    <button
      *ngIf="row.filingSubmissionStatusId !== FilingSubmissionStatus.eFormSubmissionError"
      data-automation-id="draft-eforms-queue_202127111208"
      mat-menu-item
      (click)="onDiscard(row)"
    >
      <span>Discard Draft</span>
    </button>
  </mat-menu>

  <button
    *ngIf="appMenu?.items?.length > 0"
    mat-button
    class="mat-simple-button"
    color="primary"
    data-automation-id="draft-eforms-queue_202127111212"
    [matMenuTriggerFor]="appMenu"
    aria-label="Open Row Actions Menu"
  >
      <mat-icon iconPositionStart style="order: 1 !important; margin-right: 8px !important; margin-left: 0 !important;">list</mat-icon>
  
  <span style="order: 2 !important;">Actions</span>
  </button>
</ng-template>
